var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEthereumLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: "100%",
    height: "100%",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    imageRendering: "optimizeQuality",
    fillRule: "evenodd",
    clipRule: "evenodd",
    viewBox: "0 0 784.37 1277.39",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlnsXodm: "http://www.corel.com/coreldraw/odm/2003",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_x0020_1"
  }, /*#__PURE__*/React.createElement("metadata", {
    id: "CorelCorpID_0Corel-Layer"
  }), /*#__PURE__*/React.createElement("g", {
    id: "_1421394342400"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#343434",
    fillRule: "nonzero",
    points: "392.07,0 383.5,29.11 383.5,873.74 392.07,882.29 784.13,650.54 "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#8C8C8C",
    fillRule: "nonzero",
    points: "392.07,0 -0,650.54 392.07,882.29 392.07,472.33 "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#3C3C3B",
    fillRule: "nonzero",
    points: "392.07,956.52 387.24,962.41 387.24,1263.28 392.07,1277.38 784.37,724.89 "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#8C8C8C",
    fillRule: "nonzero",
    points: "392.07,1277.38 392.07,956.52 -0,724.89 "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#141414",
    fillRule: "nonzero",
    points: "392.07,882.29 784.13,650.54 392.07,472.33 "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#393939",
    fillRule: "nonzero",
    points: "0,650.54 392.07,882.29 392.07,472.33 "
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEthereumLogo);
export default __webpack_public_path__ + "static/media/ethereum-logo.3fd82e9f35ffed062794d2e5cfb7e7e8.svg";
export { ForwardRef as ReactComponent };